import { SvgIcon } from '@mui/material';
import { memo } from 'react';

function IntakeIcon(props) {
  return (
    <SvgIcon viewBox='0 0 24 24' {...props}>
      <path
        d='M5 20V9.5l7-5.3 7 5.3V20h-1V10l-6-4.55L6 10v10Zm3.5-1.025h7v-3h-7Zm0-4h7v-3h-7Zm-1 5v-9h9v9Z'
        stroke='none'
        fill='currentColor'
      />
    </SvgIcon>
  );
}

export default memo(IntakeIcon);
